import { Component, Vue } from 'vue-property-decorator';
import McIcon from '@/components/icons/mc-icon/mc-icon';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import axios from 'axios';
import { registryAPI } from '@/providers/apis/registry/registry';
import { DEFAULT_IMAGES_PATH, PARTNERS_TYPE_OBJECT_ARRAY_WISE } from '@/utils/constants';
import { mapDataSetAPI } from '@/providers/apis/app/map-dataset';
import { partnersAPI } from '@/providers/apis/partners/partners';
import { formatTime } from '@/utils/date';
import moment from 'moment';
import { getShortNumber } from '@/utils/utils';

@Component({
  name: 'partner-profile-details',
  components: {

    'google-material-icon': GoogleMaterialIcon,
    'font-awesome-icon': FontAwesomeIcon,
    'mc-icon': McIcon,
  },
})

export default class PartnerProfileDetails extends Vue {

  // -------------------------------------------------
  // Properties

  /**
   * Maintains the data of map plotting values
   */

  private partnerData: any = null;

  private partnerRegistry: boolean = false;

  private summaryDataValue: boolean = true;

  private additionalInfoValue: boolean = true;

  private WorkDataValue: boolean = true;

  private countryDataValue: boolean = true;

  private videoDataValue: boolean = true;

  private linkDataValue: boolean = true;

  private videoContainer: any = [];

  private addtionalLinkdata: any = [];

  private videoResponceData: any = [];

  private addtionalLinkResponceData: any = [];

  private isshowToolProfile: boolean = false;

  private defaultPartnerImage: string = DEFAULT_IMAGES_PATH.partner;

  private selectedImage: string = '';

  private partnerType: any = PARTNERS_TYPE_OBJECT_ARRAY_WISE;

  // -------------------------------------------------
  // Hooks
  private async created() {
    if (this.$route.name === 'partners-network-profile') {
      this.partnerRegistry = true;
      this.showPartenrProfileData();
    } else {
      this.partnerRegistry = false;
      this.isshowToolProfile = this.$route.name === 'tool-network-profile' ? true : false;
      this.partnerData = this.$store.state.activityStore.selectedData;
    }
  }

  // --------------------------------------------------
  // Methods
  private async fetchPartnerProfileMapData() {
    return registryAPI.fetchRegistryList();
  }

  // --------------------------------------------------
  // Actions
  private back() {
    this.$router.back();
  }

  private showPartenrProfileData() {
    partnersAPI.getPartnerById(this.$route.params.id).then((data) => {
      this.partnerData = data;
    });
    const defaultVideo = this.videoResponceData;
    this.videoContainer = defaultVideo.slice(0, 2);
    const defaultAddtionalValue = this.addtionalLinkResponceData;
    this.addtionalLinkdata = defaultAddtionalValue.slice(0, 3);
  }

  private onClickVideo() {
    const count = this.videoContainer.length + 2;
    if (this.videoContainer.length !== this.videoResponceData.length) {
      const videoValue = this.videoResponceData;
      this.videoContainer = videoValue.slice(0, count);
    }
  }

  private onClickAddtionalLink() {
    const count = this.addtionalLinkdata.length + 3;
    if (this.addtionalLinkdata.length !== this.addtionalLinkResponceData.length) {
      const addtionalValue = this.addtionalLinkResponceData;
      this.addtionalLinkdata = addtionalValue.slice(0, count);
    }
  }

  private convertTimeFormat(timeInMillis: number) {
    const timeSpent = moment(timeInMillis);
    return `${timeSpent.format('hh')} Hours ${timeSpent.format('mm')} Minutes `;
  }

  private imgLoad() {
    const partnerImage = this.$refs.partnerImage as any;
    const imageNotLoad = this.$refs.imageNotLoad as any;
    partnerImage[0].style.display = 'block';
    imageNotLoad[0].style.display = 'none';
  }

  private shortNumber( value: number, args?: any ): any {
    return getShortNumber( value );
  }
}
